import React from 'react';
import { makeStyles } from '~/lib/bn-material-ui';

const useStyles = makeStyles((theme) => {
  return {
    predicted: {
      background: theme.palette.primary.main,
    },
    futureRefill: {
      backgroundColor: theme.palette.lavender[60],
      opacity: 0.5,
    },
    fill: {
      borderTopLeftRadius: '2px',
      borderTopRightRadius: '2px',
      position: 'absolute',
      bottom: 0,
      width: '100%',
      zIndex: 2,
    },
    container: {
      flex: 1,
      position: 'relative',
      overflow: 'hidden',
      margin: '0 1px',
    },
  };
});

export default function BinLevelForecast({ level, fullTotal, orderForecast }) {
  const styles = useStyles();
  const volume = level.low;
  const fillHeightPercent = Math.min(volume / fullTotal * 100, 100);
  const orderHeightPercent = Math.min(orderForecast / fullTotal * 100, 100 - fillHeightPercent);

  return (
    <div className={styles.container}>
      <div className={`${styles.fill} ${styles.futureRefill}`} style={{ height: `${orderHeightPercent}%`, bottom: `${fillHeightPercent}%` }} />
      <div className={`${styles.fill} ${styles.predicted}`} style={{ height: `${fillHeightPercent}%` }} />
    </div>
  );
}
